import React, {FunctionComponent, useEffect, useState} from "react";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import {OurModalProps} from "./OurModalTypes";
import "./OurModal.scss";

const OurModal: FunctionComponent<OurModalProps> = (commissionModalProps) => {
  const {children, disableClose, parentToggle, setParentClose, ariaLabel, ariaLabelledBy} = commissionModalProps;
  const [isOpen, setIsOpen] = useState<boolean>(parentToggle);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      return;
    }

    setIsOpen(parentToggle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentToggle])

  function handleClose() {
    if (!disableClose) {
      setIsOpen(false);
      setParentClose(false);
    }
  }

  return (
    <Modal
      className="our-modal"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
      open={isOpen}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.65)",
          backdropFilter: "blur(4px)",
          // The backdrop is position:fixed, so without this it paints above the modal's own
          // (non-positioned) children regardless of DOM order and blurs them along with the page.
          zIndex: -1,
        },
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div className="popup-base">
          {children}
        </div>
      </Fade>
    </Modal>
  )
}

export default OurModal;
